$(document).ready(function () {
    setTimeout(function () { 
        $('.swiper-wrapper > .banner-carousel__item').removeAttr('role','group');
        $('.swiper-wrapper > .banner-carousel__item').removeAttr('aria-label','1 / 1');
        $('.subcollection__item').removeAttr('aria-label');
        $('.subcollection__item').removeAttr('role');
        $('.write-question-review-buttons-container').attr('role','tablist');
        $('.choices__list .choices__item.choices__item--selectable').removeAttr('aria-selected');
        $('.choices.select__desktop').removeAttr('role');
        $('.choices.select__desktop').removeAttr('aria-expanded');
        $('.choices.select__desktop').removeAttr('aria-haspopup');
        $('.glider-dots.glider-d-3 button').removeAttr('role','tab');
        $('.rc-tooltip a.learn-more').append('<span class="visually-hidden">Recharge Payment</span>');
        $('.reviews-header .reviews-amount').attr('role','heading');
        $('.slider__arrow--prev').attr('aria-label','Previous Slide');
        $('.slider__arrow--next').attr('aria-label','Next Slide');
}, 3000);
}, 3000);
$("ul.list-menu li.mega-menu-item ").focus(function(){
    $(this).toggleClass("oopen");
    $(this).siblings().removeClass("oopen");
});
// $("ul.list-menu li.mega-menu-item a").removeAttr("[href='/collections/all-supplements']");
// $("ul.list-menu li.mega-menu-item a").attr('role','button');
// $("ul.list-menu li.mega-menu-item a").removeAttr('[href="/collections/apparel"]');
// $("ul.list-menu li.mega-menu-item a").attr('role','button');
$('.no-br br').attr('aria-hidden', 'true');
$('a[target="_blank"]').attr('aria-describedby','hmw');
$('body').prepend('<span id="hmw" style="font-size:0; position: fixed; top:0;" aria-hidden="true">This link open in new tab</span>');
$('.sc-jtXEFf.jydWoQ.pf-13_ span a').attr('aria-describedby','subscribe');
$('body').prepend('<span id="subscribe" style="font-size:0; position: fixed; top:0;" aria-hidden="true">You will leaving ehplabs.com to a booking system on ehplabs.us9.list-manage.com</span>');
$("a[href='https://www.facebook.com/groups/613080269924961']").attr('target', '_blank');
var intervalID = window.setInterval(myCallback, 50);
      function myCallback() {
          var textAreaCheck = document.getElementsByClassName('g-recaptcha-response');
          if (textAreaCheck.length > 0) {
                 jQuery(textAreaCheck).attr('aria-label', 'g-recaptcha-response');
                 console.log(jQuery(textAreaCheck));
            clearInterval(intervalID);
          }
       }  

